/**
 * Owner: Masa Bayu
 * File: authority.ts
 * Date:Time: 2026-09-15 19:18
 * Description: QXRead T0 ecosystem authority boundaries (immutable contracts).
 */
/** Layers QXRead must never absorb as ownership. */
export const QXREAD_FOREIGN_AUTHORITIES = [
    'qxw-authoring-truth',
    'qxp-publication-truth',
    'qxwriter-authoring-execution',
    'qxreader-reading-execution',
    'adam-intelligence-execution',
];
/** What QXRead owns in the ecosystem. */
export const QXREAD_OWNED_AUTHORITIES = [
    'marketplace',
    'commerce',
    'entitlement',
    'library',
    'ecosystem-identity',
    'catalog-reference',
];
export const QXREAD_AUTHORITY_HIERARCHY = ['qxp', 'qxreader', 'qxread', 'adam-reader'];
/** Forbidden operations on foundation surfaces. */
export const QXREAD_FOUNDATION_FORBIDDEN = [
    'mutateQxp',
    'mutateQxw',
    'executeFlip',
    'grantEntitlementFromUi',
    'treatSessionAsEntitlement',
    'storePublicationTruth',
    'controlQxwriter',
    'controlQxreaderRuntime',
    'storeAffiliateInQxp',
    'storeReferralInQxp',
    'requireSellerAffiliateConfig',
    'requireSellerReferralConfig',
    'mergeAffiliateWithReferral',
    'mergeRbsWithServiceFee',
    'mergeRbsWithAffiliate',
    'mergeRbsWithReferral',
    'treatAffiliateAsSellerCommissionConfig',
    'mintRewardBalanceFromUi',
    'mutateRewardBalanceFromUi',
    'fundRewardFromSellerPrice',
    'makeRewardAvailableAtCheckout',
    'mergeAffiliateBalanceIntoReferralLedger',
    'treatRewardAsPointsOnly',
    'executeWithdrawalFromUiWithoutLedger',
    'mutateQxpFromCatalog',
    'storeQxpBytesInCatalog',
    'executeReaderFromCatalog',
    'mintEntitlementFromListing',
];
export function isQxreadForeignAuthority(value) {
    return (typeof value === 'string' && QXREAD_FOREIGN_AUTHORITIES.includes(value));
}
export function assertNoForbiddenFoundationKey(record, label) {
    for (const key of Object.keys(record)) {
        if (QXREAD_FOUNDATION_FORBIDDEN.includes(key)) {
            throw new Error(`${label} must not include forbidden field "${key}"`);
        }
    }
}
//# sourceMappingURL=authority.js.map